import AOS from "aos";
export default class Timeline {
    constructor(el) {
        this.el = el;
        this.init();
    }
    init() {
        AOS.init({
            once: true,
        });
    }
}